import React from "react";
import useAvailableOptions from "./hooks/useAvailableOptions";
import { Menu } from "semantic-ui-react";

const DropdownOptions = ({ options }) => {
  return options.map(option => (
    <div className="hover:border-b-[2px] hover:border-solid hover:border-primary">
      <a
        className="dropdown__option tracking-normal !text-[14px] font-normal hover:cursor-pointer transition-all duration-300 mb-2"
        target="_blank"
        rel="noopener noreferrer"
        href={option.url}
        style={{
          fontFamily:
            "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif !important;",
        }}
      >
        {option.text}
      </a>
    </div>
  ));
};

function MenuDropdown() {
  const options = useAvailableOptions();
  if (options)
    return (
      <Menu.Item className="service__dropdown">
        <div
          id="menu-drop-down"
          className="menu__drop__down hover:border-b-[2px] hover:border-solid hover:border-primary"
        >
          <div
            className="!text-[14px] tracking-normal font-normal"
            style={{
              fontFamily:
                "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif !important;",
            }}
          >
            Support
          </div>
          <div className="dropdown__body !mb-[2px] flex flex-col w-fit px-8 absolute bg-main-background-color top-[27px] z-30 left-1/2 -translate-x-1/2">
            <DropdownOptions options={options} />
          </div>
        </div>
      </Menu.Item>
    );
  return null;
}

export default MenuDropdown;
